import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { StyledButton, StyledCancelButton } from '../component/StyledComponent';

export default function DeleteDialog({ open, setOpen,onSubmit,name }) {

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                fullWidth
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{textTransform:'capitalize'}}>
                 Delete {name}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure want to delete this {name}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <StyledCancelButton onClick={handleClose} variant="outlined">Cancel</StyledCancelButton>
                    <StyledButton onClick={onSubmit} autoFocus>
                    Delete
                    </StyledButton>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
